module.exports = __webpack_public_path__ + "img/across-benlea-to-mount.6d0709a9.jpg";